__webpack_require__.S = {};
const initPromises = {};
const initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	let initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	const scope = __webpack_require__.S[name];
	const warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	const uniqueName = "dashboard-ui-shell";
	const register = (name, version, factory, eager) => {
		const versions = scope[name] ||= {};
		const activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	const initExternal = (id) => {
		const handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			const module = __webpack_require__(id);
			if(!module) return;
			const initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			const initResult = initFn(module);
			if(initResult?.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	const promises = [];
	switch(name) {
		case "default": {
			register("@datadog/browser-rum", "6.33.0", () => (Promise.all([__webpack_require__.e(56096), __webpack_require__.e(75562)]).then(() => (() => (__webpack_require__(75562))))));
			register("@xendit/ui-toolkit", "1.0.1", () => (Promise.all([__webpack_require__.e(82852), __webpack_require__.e(20458), __webpack_require__.e(30076), __webpack_require__.e(76852)]).then(() => (() => (__webpack_require__(68444))))));
			register("@xendit/xendit-design-system", "0.62.3", () => (Promise.all([__webpack_require__.e(11534), __webpack_require__.e(20458), __webpack_require__.e(97006)]).then(() => (() => (__webpack_require__(11534))))));
			register("@xendit/xsh-dashboard-utils/auth", "0.4.17", () => (Promise.all([__webpack_require__.e(93509), __webpack_require__.e(9273), __webpack_require__.e(58394), __webpack_require__.e(26157), __webpack_require__.e(37935)]).then(() => (() => (__webpack_require__(9273))))));
			register("@xendit/xsh-dashboard-utils/dynamic-remote", "0.4.17", () => (Promise.all([__webpack_require__.e(9963), __webpack_require__.e(75600), __webpack_require__.e(58394), __webpack_require__.e(14681)]).then(() => (() => (__webpack_require__(75600))))));
			register("@xendit/xsh-dashboard-utils/fetch", "0.4.17", () => (() => (__webpack_require__(52620))), 1);
			register("@xendit/xsh-dashboard-utils/legacy", "0.4.17", () => (__webpack_require__.e(55453).then(() => (() => (__webpack_require__(55453))))));
			register("@xendit/xsh-dashboard-utils/states", "0.4.17", () => (Promise.all([__webpack_require__.e(9963), __webpack_require__.e(93509), __webpack_require__.e(58394), __webpack_require__.e(17263)]).then(() => (() => (__webpack_require__(39644))))));
			register("i18next", "23.16.8", () => (__webpack_require__.e(9117).then(() => (() => (__webpack_require__(9117))))));
			register("jotai/utils", "2.20.3", () => (() => (__webpack_require__(79276))), 1);
			register("jotai", "2.20.3", () => (() => (__webpack_require__(91104))), 1);
			register("launchdarkly-react-client-sdk", "3.9.0", () => (Promise.all([__webpack_require__.e(98121), __webpack_require__.e(51124)]).then(() => (() => (__webpack_require__(98121))))));
			register("react-dom", "18.3.1", () => (() => (__webpack_require__(51567))), 1);
			register("react-google-recaptcha", "2.1.0", () => (__webpack_require__.e(21954).then(() => (() => (__webpack_require__(99573))))));
			register("react-i18next", "14.1.3", () => (__webpack_require__.e(26114).then(() => (() => (__webpack_require__(26114))))));
			register("react-redux", "9.3.0", () => (__webpack_require__.e(52847).then(() => (() => (__webpack_require__(52847))))));
			register("react-router-dom", "5.2.0", () => (Promise.all([__webpack_require__.e(39871), __webpack_require__.e(42380)]).then(() => (() => (__webpack_require__(39871))))));
			register("react", "18.3.1", () => (() => (__webpack_require__(66830))), 1);
			register("redux", "5.0.1", () => (__webpack_require__.e(32386).then(() => (() => (__webpack_require__(32386))))));
			register("styled-components", "4.4.1", () => (__webpack_require__.e(55968).then(() => (() => (__webpack_require__(55968))))));
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};